import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

interface RemoveVars {
	groupId: number;
	userId: string;
}

const removeGroupMember = async ({ groupId, userId }: RemoveVars) => {
	await cmsClient.delete<unknown>(
		`/users/groups/${groupId}/members/${userId}/`
	);
};

const useRemoveGroupMember = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Member removed" />, {
			hideProgressBar: true
		});
	};

	const onSettled = (_: unknown, __: unknown, variables: RemoveVars) => {
		queryClient.invalidateQueries(["group-members"]);
		queryClient.invalidateQueries(["group-member-ids", variables.groupId]);
		queryClient.invalidateQueries(["admin-groups"]);
		queryClient.invalidateQueries(["admin-groups-paged"]);
		queryClient.invalidateQueries(["admin-group", variables.groupId]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	return useMutation(removeGroupMember, {
		onError,
		onSuccess,
		onSettled
	});
};

export default useRemoveGroupMember;
